import React, { useState, useEffect } from 'react';
import { Calculator, DollarSign, TrendingUp, Users, Building, FileText, Download, RefreshCw, Mail, Eye, Edit, Trash2, Filter } from 'lucide-react';

const Commissions = () => {
  const [activeTab, setActiveTab] = useState('property');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateRange, setDateRange] = useState('month');
  
  // Nouveaux états pour la gestion des prestations
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('all');
  const [showServiceStatement, setShowServiceStatement] = useState(false);
  const [editingService, setEditingService] = useState(null);

  // Mock data pour les KPIs
  const kpis = {
    totalCommissions: "€156,780",
    averageRate: "12.5%", 
    partnerCommissions: "€89,450",
    netRevenue: "€1,234,560",
    pendingTransactions: 23
  };

  // Structure des commissions
  const commissionStructure = [
    { type: "Villas Premium", rate: 15, description: "Villas de luxe >€5,000/nuit" },
    { type: "Villas Standard", rate: 12, description: "Villas classiques" },
    { type: "Yachts", rate: 18, description: "Location de yachts" },
    { type: "Services Conciergerie", rate: 20, description: "Services premium" },
    { type: "Expériences", rate: 25, description: "Activités exclusives" }
  ];

  // Données des partenaires
  const partners = [
    {
      id: 1,
      name: "Luxury Villas France",
      type: "Partenaire Premium",
      reservations: 45,
      totalVolume: "€789,230",
      shareRate: "15%",
      commission: "€118,384",
      status: "paid",
      avatar: "LV"
    },
    {
      id: 2,
      name: "Mediterranean Estates",
      type: "Partenaire Gold",
      reservations: 28,
      totalVolume: "€456,780",
      shareRate: "12%",
      commission: "€54,814",
      status: "pending",
      avatar: "ME"
    },
    {
      id: 3,
      name: "Elite Concierge Services",
      type: "Partenaire Services",
      reservations: 67,
      totalVolume: "€234,560",
      shareRate: "20%",
      commission: "€46,912",
      status: "paid",
      avatar: "EC"
    }
  ];

  // Transactions détaillées
  const transactions = [
    {
      id: "COM-2024-001",
      reservation: "RES-2024-456",
      client: "Sophie Martin",
      property: "Villa Azure",
      totalAmount: "€25,500",
      rate: "15%",
      commission: "€3,825",
      agent: "Marie Dubois",
      status: "paid"
    },
    {
      id: "COM-2024-002", 
      reservation: "RES-2024-457",
      client: "Jean Dupont",
      property: "Château Provence",
      totalAmount: "€18,900",
      rate: "12%",
      commission: "€2,268",
      agent: "Luxury Villas France",
      status: "pending"
    },
    {
      id: "COM-2024-003",
      reservation: "RES-2024-458",
      client: "Isabella Romano",
      property: "Yacht Serenity",
      totalAmount: "€42,000",
      rate: "18%",
      commission: "€7,560",
      agent: "Mediterranean Estates",
      status: "processing"
    }
  ];

  // Données du graphique mensuel
  const monthlyData = [
    { month: "Jan", amount: 125000 },
    { month: "Fév", amount: 142000 },
    { month: "Mar", amount: 156000 },
    { month: "Avr", amount: 134000 },
    { month: "Mai", amount: 168000 },
    { month: "Jun", amount: 189000 },
    { month: "Jul", amount: 224000 },
    { month: "Aoû", amount: 198000 },
    { month: "Sep", amount: 156780 }
  ];

  // Données des prestations effectuées
  const serviceProviders = [
    { id: 'all', name: 'Tous les prestataires' },
    { id: 'chef-service', name: 'Chef Service Premium' },
    { id: 'spa-wellness', name: 'Spa & Wellness Co.' },
    { id: 'yacht-management', name: 'Yacht Management Pro' },
    { id: 'concierge-luxury', name: 'Concierge Luxury Services' },
    { id: 'transport-vip', name: 'Transport VIP' },
    { id: 'event-planning', name: 'Event Planning Elite' }
  ];

  const servicesPerformed = [
    {
      id: 'SRV-2024-001',
      date: '2024-09-15',
      provider: 'Chef Service Premium',
      providerId: 'chef-service',
      client: 'Jean Dubois',
      reservation: 'RES-2024-156',
      service: 'Chef privé - Dîner gastronomique 8 personnes',
      originalAmount: 2500,
      currentAmount: 2500,
      commissionRate: 20,
      originalCommission: 500,
      currentCommission: 500,
      status: 'completed',
      paymentStatus: 'paid'
    },
    {
      id: 'SRV-2024-002',
      date: '2024-09-14',
      provider: 'Spa & Wellness Co.',
      providerId: 'spa-wellness',
      client: 'Maria Rodriguez',
      reservation: 'RES-2024-148',
      service: 'Massage wellness couple - 90 minutes',
      originalAmount: 800,
      currentAmount: 850,
      commissionRate: 25,
      originalCommission: 200,
      currentCommission: 212.5,
      status: 'completed',
      paymentStatus: 'pending'
    },
    {
      id: 'SRV-2024-003',
      date: '2024-09-13',
      provider: 'Yacht Management Pro',
      providerId: 'yacht-management',
      client: 'Alessandro Bianchi',
      reservation: 'RES-2024-142',
      service: 'Location yacht journée complète - 12 personnes',
      originalAmount: 15000,
      currentAmount: 15000,
      commissionRate: 18,
      originalCommission: 2700,
      currentCommission: 2700,
      status: 'completed',
      paymentStatus: 'paid'
    },
    {
      id: 'SRV-2024-004',
      date: '2024-09-12',
      provider: 'Concierge Luxury Services',
      providerId: 'concierge-luxury',
      client: 'Sophie Laurent',
      reservation: 'RES-2024-139',
      service: 'Service conciergerie premium - Shopping & Restaurants',
      originalAmount: 1200,
      currentAmount: 1350,
      commissionRate: 22,
      originalCommission: 264,
      currentCommission: 297,
      status: 'completed',
      paymentStatus: 'processing'
    },
    {
      id: 'SRV-2024-005',
      date: '2024-09-11',
      provider: 'Transport VIP',
      providerId: 'transport-vip',
      client: 'David Chen',
      reservation: 'RES-2024-135',
      service: 'Transfer aéroport + chauffeur privé journée',
      originalAmount: 650,
      currentAmount: 650,
      commissionRate: 15,
      originalCommission: 97.5,
      currentCommission: 97.5,
      status: 'completed',
      paymentStatus: 'paid'
    },
    {
      id: 'SRV-2024-006',
      date: '2024-09-10',
      provider: 'Event Planning Elite',
      providerId: 'event-planning',
      client: 'Isabella Martinez',
      reservation: 'RES-2024-131',
      service: 'Organisation événement anniversaire - 25 personnes',
      originalAmount: 5800,
      currentAmount: 6200,
      commissionRate: 20,
      originalCommission: 1160,
      currentCommission: 1240,
      status: 'completed',
      paymentStatus: 'pending'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'text-green-600 bg-green-100';
      case 'pending': return 'text-yellow-600 bg-yellow-100';
      case 'processing': return 'text-blue-600 bg-blue-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'paid': return 'Payé';
      case 'pending': return 'En attente';
      case 'processing': return 'En cours';
      default: return status;
    }
  };

  // Fonctions pour la gestion des prestations
  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'text-green-600 bg-green-100';
      case 'pending': return 'text-yellow-600 bg-yellow-100';
      case 'processing': return 'text-blue-600 bg-blue-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  const getPaymentStatusLabel = (status) => {
    switch (status) {
      case 'paid': return 'Payé';
      case 'pending': return 'En attente';
      case 'processing': return 'En cours';
      default: return status;
    }
  };

  const filterServices = () => {
    let filtered = servicesPerformed;
    
    // Filter by date range
    if (dateFrom) {
      filtered = filtered.filter(service => service.date >= dateFrom);
    }
    if (dateTo) {
      filtered = filtered.filter(service => service.date <= dateTo);
    }
    
    // Filter by provider
    if (selectedProvider !== 'all') {
      filtered = filtered.filter(service => service.providerId === selectedProvider);
    }
    
    return filtered;
  };

  const calculateServicesSummary = () => {
    const filtered = filterServices();
    const totalServices = filtered.length;
    const totalAmount = filtered.reduce((sum, service) => sum + service.currentAmount, 0);
    const totalCommission = filtered.reduce((sum, service) => sum + service.currentCommission, 0);
    const totalOriginalAmount = filtered.reduce((sum, service) => sum + service.originalAmount, 0);
    const totalOriginalCommission = filtered.reduce((sum, service) => sum + service.originalCommission, 0);
    
    return {
      totalServices,
      totalAmount,
      totalCommission,
      totalOriginalAmount,
      totalOriginalCommission,
      adjustment: totalAmount - totalOriginalAmount,
      commissionAdjustment: totalCommission - totalOriginalCommission
    };
  };

  const handleEditService = (serviceId) => {
    setEditingService(serviceId);
  };

  const handleSaveService = (serviceId, newAmount, newCommissionRate) => {
    // Mise à jour des données (dans un vrai app, on ferait un appel API)
    const newCommission = (newAmount * newCommissionRate) / 100;
    console.log(`Service ${serviceId} updated: Amount=${newAmount}, Commission=${newCommission}`);
    setEditingService(null);
  };

  const handleCancelEdit = () => {
    setEditingService(null);
  };

  const generateServiceStatement = () => {
    const filtered = filterServices();
    const summary = calculateServicesSummary();
    
    // Dans un vrai app, on génèrerait un PDF ou Excel
    console.log('Génération du relevé de prestations:', {
      period: `${dateFrom} - ${dateTo}`,
      provider: selectedProvider,
      services: filtered,
      summary
    });
    
    alert(`Relevé généré pour ${filtered.length} prestations\nMontant total: €${summary.totalAmount.toLocaleString()}\nCommission totale: €${summary.totalCommission.toLocaleString()}`);
  };

  return (
    <div className="commissions">
      {/* En-tête */}
      <div className="page-header bg-white border-b border-gray-200 p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Gestion des Commissions</h1>
            <p className="text-gray-600 mt-1">Suivez et gérez les commissions de vos partenaires et agents</p>
          </div>
          
          <div className="flex items-center space-x-3 mt-4 lg:mt-0">
            <button className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700">
              <Calculator size={18} />
              <span>Calculer Commission</span>
            </button>
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* KPI Cards */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
          <div className="kpi-card bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <DollarSign className="text-green-600" size={24} />
              <span className="text-sm font-medium text-green-600">+15.3%</span>
            </div>
            <div className="text-2xl font-bold text-gray-800">{kpis.totalCommissions}</div>
            <div className="text-sm text-gray-600">Commissions Totales</div>
          </div>

          <div className="kpi-card bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <TrendingUp className="text-blue-600" size={24} />
              <span className="text-sm font-medium text-blue-600">+2.1%</span>
            </div>
            <div className="text-2xl font-bold text-gray-800">{kpis.averageRate}</div>
            <div className="text-sm text-gray-600">Taux Moyen</div>
          </div>

          <div className="kpi-card bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <Users className="text-purple-600" size={24} />
              <span className="text-sm font-medium text-purple-600">+8.4%</span>
            </div>
            <div className="text-2xl font-bold text-gray-800">{kpis.partnerCommissions}</div>
            <div className="text-sm text-gray-600">Commissions Partenaires</div>
          </div>

          <div className="kpi-card bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <Building className="text-yellow-600" size={24} />
              <span className="text-sm font-medium text-green-600">+12.7%</span>
            </div>
            <div className="text-2xl font-bold text-gray-800">{kpis.netRevenue}</div>
            <div className="text-sm text-gray-600">Revenue Net PRIVIA</div>
          </div>

          <div className="kpi-card bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center justify-between mb-2">
              <FileText className="text-orange-600" size={24} />
              <span className="text-sm font-medium text-orange-600">Urgent</span>
            </div>
            <div className="text-2xl font-bold text-gray-800">{kpis.pendingTransactions}</div>
            <div className="text-sm text-gray-600">Transactions en Attente</div>
          </div>
        </div>

        {/* État des Prestations - Nouvelle Section */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-semibold text-gray-800">État des Prestations Effectuées</h3>
            <div className="flex items-center space-x-3">
              <button 
                onClick={() => setShowServiceStatement(!showServiceStatement)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  showServiceStatement 
                    ? 'bg-yellow-600 text-white hover:bg-yellow-700' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {showServiceStatement ? 'Masquer Détails' : 'Afficher Détails'}
              </button>
              <button
                onClick={generateServiceStatement}
                className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
              >
                <Download size={16} />
                <span>Générer Relevé</span>
              </button>
            </div>
          </div>

          {/* Filtres de date et prestataire */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Date de début</label>
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Date de fin</label>
              <input
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Prestataire</label>
              <select
                value={selectedProvider}
                onChange={(e) => setSelectedProvider(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              >
                {serviceProviders.map((provider) => (
                  <option key={provider.id} value={provider.id}>
                    {provider.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <button
                onClick={() => {
                  setDateFrom('');
                  setDateTo('');
                  setSelectedProvider('all');
                }}
                className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm"
              >
                Réinitialiser
              </button>
            </div>
          </div>

          {/* Résumé des prestations filtrées */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-800">{calculateServicesSummary().totalServices}</div>
              <div className="text-sm text-gray-600">Prestations</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">€{calculateServicesSummary().totalAmount.toLocaleString()}</div>
              <div className="text-sm text-gray-600">Montant Total</div>
              {calculateServicesSummary().adjustment !== 0 && (
                <div className={`text-xs ${calculateServicesSummary().adjustment > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {calculateServicesSummary().adjustment > 0 ? '+' : ''}€{calculateServicesSummary().adjustment.toLocaleString()} ajusté
                </div>
              )}
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">€{calculateServicesSummary().totalCommission.toLocaleString()}</div>
              <div className="text-sm text-gray-600">Commission Totale</div>
              {calculateServicesSummary().commissionAdjustment !== 0 && (
                <div className={`text-xs ${calculateServicesSummary().commissionAdjustment > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {calculateServicesSummary().commissionAdjustment > 0 ? '+' : ''}€{calculateServicesSummary().commissionAdjustment.toLocaleString()} ajusté
                </div>
              )}
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600">
                {calculateServicesSummary().totalAmount > 0 ? 
                  ((calculateServicesSummary().totalCommission / calculateServicesSummary().totalAmount) * 100).toFixed(1) : 0}%
              </div>
              <div className="text-sm text-gray-600">Taux Moyen</div>
            </div>
          </div>

          {/* Tableau détaillé des prestations */}
          {showServiceStatement && (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                    <th className="pb-3">Date</th>
                    <th className="pb-3">Prestataire</th>
                    <th className="pb-3">Client</th>
                    <th className="pb-3">Réservation</th>
                    <th className="pb-3">Service</th>
                    <th className="pb-3">Montant</th>
                    <th className="pb-3">Taux</th>
                    <th className="pb-3">Commission</th>
                    <th className="pb-3">Statut</th>
                    <th className="pb-3">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filterServices().map((service) => (
                    <tr key={service.id} className="hover:bg-gray-50">
                      <td className="py-4 text-sm text-gray-900">{new Date(service.date).toLocaleDateString('fr-FR')}</td>
                      <td className="py-4 text-sm font-medium text-gray-900">{service.provider}</td>
                      <td className="py-4 text-sm text-gray-900">{service.client}</td>
                      <td className="py-4 text-sm text-blue-600 hover:text-blue-700 cursor-pointer">{service.reservation}</td>
                      <td className="py-4 text-sm text-gray-900 max-w-xs truncate" title={service.service}>
                        {service.service}
                      </td>
                      <td className="py-4">
                        {editingService === service.id ? (
                          <div className="flex items-center space-x-2">
                            <input
                              type="number"
                              defaultValue={service.currentAmount}
                              className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-yellow-500"
                              step="0.01"
                              min="0"
                            />
                            <span className="text-xs text-gray-500">€</span>
                          </div>
                        ) : (
                          <div className="text-sm">
                            <div className="font-medium text-gray-900">€{service.currentAmount.toLocaleString()}</div>
                            {service.currentAmount !== service.originalAmount && (
                              <div className="text-xs text-gray-500">
                                (orig: €{service.originalAmount.toLocaleString()})
                              </div>
                            )}
                          </div>
                        )}
                      </td>
                      <td className="py-4">
                        {editingService === service.id ? (
                          <div className="flex items-center space-x-2">
                            <input
                              type="number"
                              defaultValue={service.commissionRate}
                              className="w-16 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-yellow-500"
                              step="0.1"
                              min="0"
                              max="100"
                            />
                            <span className="text-xs text-gray-500">%</span>
                          </div>
                        ) : (
                          <span className="text-sm text-gray-900">{service.commissionRate}%</span>
                        )}
                      </td>
                      <td className="py-4">
                        <div className="text-sm">
                          <div className="font-medium text-green-600">€{service.currentCommission.toLocaleString()}</div>
                          {service.currentCommission !== service.originalCommission && (
                            <div className="text-xs text-gray-500">
                              (orig: €{service.originalCommission.toLocaleString()})
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="py-4">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getPaymentStatusColor(service.paymentStatus)}`}>
                          {getPaymentStatusLabel(service.paymentStatus)}
                        </span>
                      </td>
                      <td className="py-4">
                        <div className="flex items-center space-x-2">
                          {editingService === service.id ? (
                            <>
                              <button
                                onClick={() => handleSaveService(service.id, service.currentAmount, service.commissionRate)}
                                className="text-green-600 hover:text-green-800 p-1"
                                title="Sauvegarder"
                              >
                                <Download size={14} />
                              </button>
                              <button
                                onClick={handleCancelEdit}
                                className="text-gray-600 hover:text-gray-800 p-1"
                                title="Annuler"
                              >
                                <Trash2 size={14} />
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={() => handleEditService(service.id)}
                                className="text-blue-600 hover:text-blue-800 p-1"
                                title="Modifier"
                              >
                                <Edit size={14} />
                              </button>
                              <button
                                className="text-gray-400 hover:text-gray-600 p-1"
                                title="Voir détails"
                              >
                                <Eye size={14} />
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              {filterServices().length === 0 && (
                <div className="text-center py-8 text-gray-500">
                  Aucune prestation trouvée pour les critères sélectionnés
                </div>
              )}
            </div>
          )}
        </div>

        {/* Structure des Commissions */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Structure des Commissions</h3>
            <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
              Modifier les taux
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {commissionStructure.map((item, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-gray-800">{item.type}</span>
                  <span className="text-xl font-bold text-yellow-600">{item.rate}%</span>
                </div>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Section principale */}
          <div className="lg:col-span-2 space-y-6">
            {/* Barre d'actions */}
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="flex flex-wrap items-center gap-3">
                <button className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
                  <DollarSign size={18} />
                  <span>Traiter Paiements</span>
                </button>
                <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                  <Download size={18} />
                  <span>Exporter Excel</span>
                </button>
                <button className="flex items-center space-x-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700">
                  <RefreshCw size={18} />
                  <span>Synchroniser</span>
                </button>
                <button className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">
                  <Mail size={18} />
                  <span>Envoyer Relevés</span>
                </button>
              </div>
            </div>

            {/* Filtres */}
            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="flex flex-wrap items-center gap-4">
                <select 
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                >
                  <option value="all">Tous types</option>
                  <option value="property">Propriétés</option>
                  <option value="service">Services</option>
                  <option value="partner">Partenaires</option>
                </select>
                
                <select 
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                >
                  <option value="all">Tous statuts</option>
                  <option value="paid">Payé</option>
                  <option value="pending">En attente</option>
                  <option value="processing">En cours</option>
                </select>

                <input
                  type="date"
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                />
              </div>
            </div>

            {/* Onglets de détail */}
            <div className="bg-white rounded-lg border border-gray-200">
              <div className="border-b border-gray-200">
                <nav className="flex space-x-8 px-6">
                  {[
                    { id: 'property', label: 'Par Propriété', icon: Building },
                    { id: 'agent', label: 'Par Agent', icon: Users },
                    { id: 'partner', label: 'Par Partenaire', icon: Users },
                    { id: 'destination', label: 'Par Destination', icon: Building }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex items-center space-x-2 py-4 border-b-2 font-medium text-sm ${
                        activeTab === tab.id
                          ? 'border-yellow-500 text-yellow-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <tab.icon size={18} />
                      <span>{tab.label}</span>
                    </button>
                  ))}
                </nav>
              </div>
              
              <div className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        <th className="pb-3">ID Commission</th>
                        <th className="pb-3">Réservation</th>
                        <th className="pb-3">Client</th>
                        <th className="pb-3">Propriété</th>
                        <th className="pb-3">Montant Total</th>
                        <th className="pb-3">Taux</th>
                        <th className="pb-3">Commission</th>
                        <th className="pb-3">Agent/Partenaire</th>
                        <th className="pb-3">Statut</th>
                        <th className="pb-3">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {transactions.map((transaction) => (
                        <tr key={transaction.id} className="hover:bg-gray-50">
                          <td className="py-4 text-sm font-medium text-gray-900">{transaction.id}</td>
                          <td className="py-4 text-sm text-blue-600 hover:text-blue-700 cursor-pointer">{transaction.reservation}</td>
                          <td className="py-4 text-sm text-gray-900">{transaction.client}</td>
                          <td className="py-4 text-sm text-gray-900">{transaction.property}</td>
                          <td className="py-4 text-sm font-medium text-gray-900">{transaction.totalAmount}</td>
                          <td className="py-4 text-sm text-gray-900">{transaction.rate}</td>
                          <td className="py-4 text-sm font-medium text-green-600">{transaction.commission}</td>
                          <td className="py-4 text-sm text-gray-900">{transaction.agent}</td>
                          <td className="py-4">
                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(transaction.status)}`}>
                              {getStatusLabel(transaction.status)}
                            </span>
                          </td>
                          <td className="py-4">
                            <div className="flex items-center space-x-2">
                              <button className="text-gray-400 hover:text-gray-600">
                                <Eye size={16} />
                              </button>
                              <button className="text-gray-400 hover:text-gray-600">
                                <Edit size={16} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar droite */}
          <div className="space-y-6">
            {/* Graphique Performance */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Performance Mensuelle</h3>
              <div className="space-y-3">
                {monthlyData.slice(-6).map((data) => (
                  <div key={data.month} className="flex items-center justify-between">
                    <span className="text-sm text-gray-600">{data.month}</span>
                    <div className="flex items-center space-x-2">
                      <div className="w-20 bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-yellow-600 h-2 rounded-full"
                          style={{ width: `${(data.amount / 250000) * 100}%` }}
                        ></div>
                      </div>
                      <span className="text-sm font-medium text-gray-800">
                        €{(data.amount / 1000).toFixed(0)}K
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Commissions Partenaires */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Partenaires & Agents</h3>
              <div className="space-y-4">
                {partners.map((partner) => (
                  <div key={partner.id} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex items-center space-x-3 mb-3">
                      <div className="w-10 h-10 bg-yellow-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                        {partner.avatar}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-medium text-gray-800">{partner.name}</h4>
                        <p className="text-sm text-gray-600">{partner.type}</p>
                      </div>
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(partner.status)}`}>
                        {getStatusLabel(partner.status)}
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="text-gray-600">Réservations:</span>
                        <span className="font-medium text-gray-800 ml-1">{partner.reservations}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Volume:</span>
                        <span className="font-medium text-gray-800 ml-1">{partner.totalVolume}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Taux:</span>
                        <span className="font-medium text-gray-800 ml-1">{partner.shareRate}</span>
                      </div>
                      <div>
                        <span className="text-gray-600">Commission:</span>
                        <span className="font-medium text-green-600 ml-1">{partner.commission}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commissions;